import { Button, ButtonSizes, ButtonVariant, Spacing, Text, Title } from '@rhinofi/dvf-shared-ui'
import { TitleSize } from '@rhinofi/dvf-shared-ui/lib/types/formats'
import { translate } from '../../intl/i18n'
import { Modal } from '../common/Modal/Modal'
import { PARTNERSHIPS_MAILTO } from '../../constants/shutdownNotice'

type ShutdownNoticeModalProps = {
  isVisible: boolean
  onClose: () => void
}

export const ShutdownNoticeModal = ({ isVisible, onClose }: ShutdownNoticeModalProps) => (
  <Modal isVisible={isVisible} onClose={onClose} width="540px" variant="secondary">
    <Title size={TitleSize.XS}>{translate('shutdown_notice.modal_title')}</Title>
    <Spacing size="16" />
    <Text>{translate('shutdown_notice.modal_body_1')}</Text>
    <Spacing size="12" />
    <Text>{translate('shutdown_notice.modal_body_2')}</Text>
    <Spacing size="12" />
    <Text>{translate('shutdown_notice.modal_body_3')}</Text>
    <Spacing size="24" />
    <Button
      id="shutdown-notice-contact"
      size={ButtonSizes.Large}
      fullWidth
      onClick={() => {
        window.location.href = PARTNERSHIPS_MAILTO
      }}
    >
      {translate('shutdown_notice.modal_button_contact')}
    </Button>
    <Spacing size="16" />
    <Button
      id="shutdown-notice-close"
      size={ButtonSizes.Large}
      variant={ButtonVariant.secondary}
      fullWidth
      onClick={onClose}
    >
      {translate('shutdown_notice.modal_button_close')}
    </Button>
  </Modal>
)
